import { ReCenterMapMycotoxinIcon } from '@protector/icons';
import type { AllGeoJSON } from '@turf/turf';
import { bbox } from '@turf/turf';
import type { LngLatBoundsLike, mapboxgl } from 'core/utils/map/mapbox-gl';
import type { Feature, Point } from 'geojson';
import { REGIONAL_RISK_RE_CENTER_BUTTON_CONTAINER } from '@features/regional-overview/domain/tests-id.constants';
import { REGIONAL_OVERVIEW_MAP_PADDING } from '@features/regional-overview/regional-overview.constants';
import type { RegionalOverviewPolygonFeature, RegionalOverviewProperties } from 'querys/regional-overview/regional-overview.query.models';
import type React from 'react';

import { ReCenterContainer } from './regional-risk-re-center-button.styled';

interface IRegionalRiskReCenterButton {
  mapbox?: mapboxgl.Map;
  data?: RegionalOverviewPolygonFeature[] | Feature<Point, RegionalOverviewProperties>[];
  onReCenterMap?: () => void;
}

const RegionalRiskReCenterButton: React.FC<IRegionalRiskReCenterButton> = ({ mapbox, data, onReCenterMap }) => {
  const reCenterMap = () => {
    if (!data || data.length === 0) return;

    mapbox?.fitBounds(
      bbox({
        type: 'FeatureCollection',
        features: data
      } as AllGeoJSON) as LngLatBoundsLike,
      {
        padding: REGIONAL_OVERVIEW_MAP_PADDING
      }
    );
  };

  return (
    <ReCenterContainer
      data-testid={REGIONAL_RISK_RE_CENTER_BUTTON_CONTAINER}
      onClick={onReCenterMap ?? reCenterMap}
      role='button'
      tabIndex={0}>
      <ReCenterMapMycotoxinIcon width={18} height={18} data-testid='regional-risk-re-center-button-icon' />
    </ReCenterContainer>
  );
};

export default RegionalRiskReCenterButton;
